import { render, staticRenderFns } from "./PayrollCloser.vue?vue&type=template&id=d8797a8c&scoped=true&"
import script from "./PayrollCloser.vue?vue&type=script&lang=ts&"
export * from "./PayrollCloser.vue?vue&type=script&lang=ts&"
import style0 from "./PayrollCloser.vue?vue&type=style&index=0&id=d8797a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8797a8c",
  null
  
)

export default component.exports